module.exports = __webpack_public_path__ + "img/towing2.29a9fd1c.jpg";